<script setup>
import { ref } from 'vue';

defineProps({
  referral: {
    type: Object,
    required: true,
  },
});

// Meta media URLs expire, so a broken thumbnail is hidden instead of shown
const hasImageError = ref(false);
</script>

<template>
  <div class="flex gap-3 p-2 rounded-lg bg-n-alpha-2 text-sm">
    <img
      v-if="
        referral.mediaUrl && referral.mediaType === 'image' && !hasImageError
      "
      :src="referral.mediaUrl"
      class="object-cover rounded-md size-16 shrink-0"
      @error="hasImageError = true"
    />
    <div class="flex flex-col min-w-0 gap-1">
      <span class="text-xs font-medium text-n-slate-11">
        {{ $t('CONVERSATION.AD_REFERRAL.FROM_AD') }}
      </span>
      <span v-if="referral.headline" class="font-medium text-n-slate-12">
        {{ referral.headline }}
      </span>
      <span v-if="referral.body" class="line-clamp-2 text-n-slate-11">
        {{ referral.body }}
      </span>
      <a
        v-if="referral.sourceUrl"
        :href="referral.sourceUrl"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="text-xs text-n-brand hover:underline"
      >
        {{ $t('CONVERSATION.AD_REFERRAL.VIEW_AD') }}
      </a>
    </div>
  </div>
</template>
